import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import useUserContext from '../hooks/use-user-context';

import AnchorElement from './AnchorElement';

const Personalization = ({ children, options }) => {
  const { region, language, developerRegions, abTests } = useUserContext();

  if (options === null || options === undefined || options.length === 0) {
    return children;
  }

  const match = options.reduce((acc, option) => {
    let show = true;

    if (option.pricingRegions !== null && option.pricingRegions.length > 0) {
      show = show && option.pricingRegions.includes(region);
    }

    if (option.developerRegions !== null && option.developerRegions.length > 0) {
      const hasMatchingDevRegions = option.developerRegions.some(
        (item) => developerRegions.includes(item)
      );
      show = show && hasMatchingDevRegions;
    }

    if (option.languages !== null && option.languages.length > 0) {
      show = show && option.languages.includes(language);
    }

    if (option.abTestName !== null) {
      show = show && abTests.includes(option.abTestName);
    }

    return acc && (show ? option.display : !option.display);
  }, true);

  if (!match) {
    return null;
  }

  const anchorId = options.find((option) => option.anchorId !== null)?.anchorId;

  if (anchorId) {
    return (
      <>
        <AnchorElement id={anchorId} />
        {children}
      </>
    );
  }

  return children;
};

Personalization.propTypes = {
  children: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      anchorId: PropTypes.string,
      display: PropTypes.bool,
      pricingRegions: PropTypes.arrayOf(PropTypes.string),
      developerRegions: PropTypes.arrayOf(PropTypes.string),
      languages: PropTypes.arrayOf(PropTypes.string),
      abTestName: PropTypes.string
    })
  )
};

export const query = graphql`
  fragment PersonalizationFragment on ContentfulPersonalization {
    anchorId
    display
    pricingRegions
    developerRegions
    languages
    abTestName
  }
`;

export default Personalization;
